import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import FormContainer from '../../components/formContainer/formContainer'
import { TextInput, ImageUploadInput, SingleCheckBoxInput } from '../../components/input/inputModule'
import { getDuzenleData } from '../helpers/componentApiHelpers/getDuzenleData'
import { sendDataUpload, changeDataUpload } from '../helpers/componentApiHelpers/sendData'
import { getIdFromUrl } from '../helpers/getIdFromUrl'
import { getCall } from '../helpers/componentApiHelpers/getCall'

class SonucCicekResimGaleriEnter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            resultType: "",
            image: "",
            dataCame: false
        }
        this.onValChange = this.onValChange.bind(this)
    }

    async componentDidMount() {
        let id = getIdFromUrl(this.props.history.location.pathname, 2)
        await this.setState({ resultType: id })
        await getDuzenleData(3, "resultCicekGaleri", this)
    }

    async onValChange(e, stateProp) {
        e.preventDefault()
        await this.setState({ [stateProp]: e.target.value })
    }

    async send() {
        if (this.state.id === "" || this.state.id === undefined) {
            await sendDataUpload("/resultCicekGaleri", "/sonucCicekResimGaleri/" + this.state.resultType, this)
        } else {
            await changeDataUpload("/resultCicekGaleri/", "/sonucCicekResimGaleri/" + this.state.resultType, this)
        }
    }

    render() {
        return (
            <React.Fragment>
                <HeaderLine header="Ekle" />
                <FormContainer
                    sending={this.state.sending}
                    dataCame={getIdFromUrl(this.props.history.location.pathname, 2) !== undefined && !this.state.dataCame}
                >
                    <p className="main-paragraph">Sonuç Çiçek Galeri</p>
                    <ImageUploadInput id="image" stateProp="image" value={this.state.image} onChange={this.onValChange} />
                    {this.state.errorMessage && <p style={{ color: "red" }}>{this.state.errorMessage}</p>}
                    <button onClick={() => this.send()} className="save-button">Ekle</button>
                </FormContainer>
            </React.Fragment>
        )
    }
}

export default SonucCicekResimGaleriEnter